import api from '@/api';

const state = {
	items: [],
	updated: 0,
};

const getters = {};

const actions = {
	get: ({ commit }, { refresh = false, updateStore = false, ...params }) => {
		return new Promise((resolve, reject) => {
			const { updated } = state;
			if (!refresh && updated > 0) {
				resolve({ data: { items: state.items } });
			}
			api.pipeline.interview
				.get(params)
				.then(response => {
					if (updateStore) {
						const { items } = response.data;
						commit('setItems', { items });
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	post: ({ commit }, { updateStore = false, ...params }) => {
		return new Promise((resolve, reject) => {
			api.pipeline.interview
				.post(params)
				.then(response => {
					if (updateStore) {
						const { items } = response.data;
						commit('addItems', { items });
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	put: ({ commit }, { updateStore = false, ...params }) => {
		return new Promise((resolve, reject) => {
			api.pipeline.interview
				.put(params)
				.then(response => {
					if (updateStore) {
						const { items } = response.data;
						commit('updateItems', { items });
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
};

const mutations = {
	setItems: (state, { items }) => {
		const now = new Date();
		state.items = items;
		state.updated = now.getTime();
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
